// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "",
  numero_telefono: "",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  */

  urlWeb: 'https://discentya.tecnocapgroup.academy/',
  urlMaterialeDidattico: 'https://discentya.tecnocapgroup.academy/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://discentya.tecnocapgroup.academy/assets/media/corso/',
  urlImageCorsoHD: 'https://discentya.tecnocapgroup.academy/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://discentya.tecnocapgroup.academy/assets/media/corso/video/',
  web_api_url_base: 'https://discentya.tecnocapgroup.academy/api/',

  urlStampa: 'https://discentya.tecnocapgroup.academy/stampe/',

  urlAttestati: 'https://discentya.tecnocapgroup.academy/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://discentya.tecnocapgroup.academy/pages/certificate/',
  urlImagePartners: 'https://discentya.tecnocapgroup.academy/assets/media/partners/',

};

